export default "__VITE_ASSET__ozzbeCMP__"